__turbopack_context__.v({
  "backdrop": "FixedPositioningAroundElement-module-scss-module__g5biCa__backdrop",
  "dropdown": "FixedPositioningAroundElement-module-scss-module__g5biCa__dropdown",
  "dropdown-hide": "FixedPositioningAroundElement-module-scss-module__g5biCa__dropdown-hide",
});
